"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Position = void 0;
var Position = exports.Position = /*#__PURE__*/function (Position) {
  Position["TOP"] = "top";
  Position["BOTTOM"] = "bottom";
  Position["LEFT"] = "left";
  Position["RIGHT"] = "right";
  Position["TOP_LEFT"] = "topLeft";
  Position["TOP_RIGHT"] = "topRight";
  Position["BOTTOM_LEFT"] = "bottomLeft";
  Position["BOTTOM_RIGHT"] = "bottomRight";
  return Position;
}(Position || {});